import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=0111ea24&scoped=true"
import script from "./forum.vue?vue&type=script&lang=js"
export * from "./forum.vue?vue&type=script&lang=js"
import style0 from "./forum.vue?vue&type=style&index=0&id=0111ea24&prod&lang=scss&scoped=true"
import style1 from "./forum.vue?vue&type=style&index=1&id=0111ea24&prod&lang=scss"
import style2 from "./forum.vue?vue&type=style&index=2&id=0111ea24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0111ea24",
  null
  
)

export default component.exports